import { Col, Container, Row, Button } from "reactstrap";
import { Link } from "react-router-dom";

import btnMulai from '../../../assets/images/game/w2_buttons/mulai_game.png';
import qoutes from '../../../assets/images/game/w2_assets/qoutes-w2.png';
import hiasan1 from '../../../assets/images/game/w2_assets/Asset-76.png';
import hiasan2 from '../../../assets/images/game/w2_assets/Asset-75.png';
import hiasan3 from '../../../assets/images/game/w2_assets/Asset-73.png';
import hiasan4 from '../../../assets/images/game/w2_assets/Asset-74.png';

const WelcomeSection = ({ scrollEvents }) => {
    return (
        <>
            <Container className="h-100 position-relative front">
                <Row className="h-100">
                    <Col md="12" className="text-center my-auto mt-5 position-relative">
                        <h2 className="judul-game-1 marko-one mb-4 text-white">
                            Halo, Kamu telah sampai di Nitijana Game Section!
                        </h2>
                        <p className="content-game-1 montserrat mb-4 text-white">
                            Kini, kamu berperan sebagai pengguna aktif sosial media yang ingin <br /> mengasah pengetahuan <b>literasi digital</b>-mu <br /><b>seputar hoaks dan cek fakta</b> mandiri.
                        </p>
                        <img src={qoutes} alt="quotes" className="img-quotes" /><br/>
                        <button onClick={scrollEvents} className="border-0 bg-transparent mt-4">
                            <img src={btnMulai} alt="Mulai Game" className="btn-mulai-game" />
                        </button>
                    </Col>
                </Row>
            </Container>
            <div className="position-relative img-asset">
                <img src={hiasan1} alt="hiasan-1" className="asset-1" />
                <img src={hiasan2} alt="hiasan-2" className="asset-2" />
                <img src={hiasan3} alt="hiasan-3" className="asset-3" />
                <img src={hiasan4} alt="hiasan-4" className="asset-4" />
            </div>
        </>
    )
}

export default WelcomeSection